import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { IconStack2, IconChevronRight } from "@tabler/icons-react";
import { Tooltip } from "@altimateai/lego";
import { api } from "@/helpers/apis";
import { SpacesTag } from "@/helpers/spacesConstants";
import z from "zod";

interface SpacesRedirectionButtonProps {
  tag: SpacesTag;
  className?: string;
}

const SpacesRedirectionButton = ({ tag, className = "" }: SpacesRedirectionButtonProps) => {
  const { data: hasDashboard, isLoading } = useQuery({
    queryKey: ["has-dashboard-tag", tag],
    queryFn: async () => await api.get<boolean>(`/metabase/has-tag`, { tag }, 0, z.boolean()),
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  // Normalize boolean since axios interceptor returns the whole response when data is false
  const isAvailable = typeof hasDashboard === "boolean" ? hasDashboard : false;
  // Don't render if loading or no dashboard exists for this tag
  if (isLoading || !isAvailable) {
    return null;
  }

  return (
    <Tooltip
      title={`Click here to access advanced insights regarding this section in the ${tag} space`}
    >
      <Link
        to={`/spaces?tags=${encodeURIComponent(tag)}`}
        className={`al-flex al-items-center al-gap-2 !al-rounded-full al-h-9 al-px-4 al-border al-border-[#9382D9] al-bg-[#F4F2FB] al-text-[#351F89] al-text-[12px] al-leading-[18px] al-font-medium ${className} hover:al-bg-[#F4F2FB] hover:al-text-[#351F89] hover:al-border-[#9382D9] al-no-underline`}
      >
        <IconStack2 className="al-w-4 al-h-4 al-text-[#351F89]" />
        <span>Insights in Space</span>
        <IconChevronRight className="al-w-4 al-h-4 al-text-[#351F89]" />
      </Link>
    </Tooltip>
  );
};

export default SpacesRedirectionButton;
